import React, { useState } from 'react'
import { Button, Group, LoadingOverlay, Modal, Stack, Text, TextInput, Title } from '@mantine/core'
import { useCloneReport } from '../../../hooks/reports/use-clone-report'
import { useHistory } from 'react-router'

type CloneReportModalProps = {
    opened: boolean
    onClose: () => void
    reportPk: number
    categoryPk: number
    scopeCode: string
}

export const CloneReportModal = ({ opened, onClose, reportPk, categoryPk, scopeCode }: CloneReportModalProps) => {
    const [newReportName, setNewReportName] = useState('')
    const { mutate: cloneReport, isLoading, isError, error, isSuccess, data: cloneResponse, reset } = useCloneReport()
    const history = useHistory()

    if (isSuccess) {
        reset()
        onClose()
        history.replace(`/reports/${cloneResponse.report_pk.toString()}`)
    }

    return (
        <Modal size='auto' opened={opened} onClose={onClose}>
            <LoadingOverlay visible={isLoading} />
            <Stack h={300} w={850} justify='space-between'>
                <Stack>
                    <Title order={5} fw='normal'>Clone Report</Title>
                    <TextInput label='New report name' placeholder='Enter new report name' value={newReportName} onChange={(e) => {
                        setNewReportName(e.target.value)
                        reset()
                    }} />
                </Stack>
                <Stack>
                    { isError && error instanceof Error && <Text c='red'>{ error.message }</Text> }
                    <Group justify='flex-end'>
                        <Button variant='outline' onClick={onClose}>Cancel</Button>
                        <Button disabled={!newReportName.length} onClick={() => cloneReport({ report_pk: reportPk, category_pk: categoryPk, new_report_scope_code: scopeCode, new_report_name: newReportName })}>Clone</Button>
                    </Group>
                </Stack>
            </Stack>
        </Modal>
    )
}